import { render, staticRenderFns } from "./HeaderNewBubble.vue?vue&type=template&id=29d2324f&scoped=true"
import script from "./HeaderNewBubble.vue?vue&type=script&lang=ts"
export * from "./HeaderNewBubble.vue?vue&type=script&lang=ts"
import style0 from "./HeaderNewBubble.vue?vue&type=style&index=0&id=29d2324f&prod&lang=scss&scoped=true"
import style1 from "./HeaderNewBubble.vue?vue&type=style&index=1&id=29d2324f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d2324f",
  null
  
)

export default component.exports